import { render, staticRenderFns } from "./invoiceDetailPage.vue?vue&type=template&id=5003e7e0&scoped=true&"
import script from "./invoiceDetailPage.vue?vue&type=script&lang=js&"
export * from "./invoiceDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetailPage.vue?vue&type=style&index=0&id=5003e7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5003e7e0",
  null
  
)

export default component.exports